import Modal from './Modal';

/**
 * 待ち状態を表示するモーダル
 * @returns
 */
function SpinnerModal() {
  return (
    <Modal
      active
      additionalClassName="popupfr340"
      displayCloseButton={false}
      onClose={() => {
        /* do nothing */
      }}
    >
      <div className="center">
        <i className="fas fa-spinner fa-spin" />
      </div>
    </Modal>
  );
}

export default SpinnerModal;
